/**
 * @generated SignedSource<<bbf89fa88d9a79132f12ff220f9f9086>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type lastUpdatedCell_softwareCodePage$data = {
  readonly lastUpdated: AGG$DateTime;
  readonly " $fragmentType": "lastUpdatedCell_softwareCodePage";
};
export type lastUpdatedCell_softwareCodePage$key = {
  readonly " $data"?: lastUpdatedCell_softwareCodePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"lastUpdatedCell_softwareCodePage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "lastUpdatedCell_softwareCodePage",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "lastUpdated"
      },
      "action": "THROW",
      "path": "lastUpdated"
    }
  ],
  "type": "DevOpsPullRequestDetails"
};

(node as any).hash = "3461a00fcd90be0ca63b25ce428bc3e0";

export default node;
